import { NgModule } from '@angular/core';

// Router
import { RouterModule, Routes } from '@angular/router';

// Component
import { SsoComponent } from './sso.component';

const routes: Routes = [{ path: 'sso', component: SsoComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SsoRoutingModule {}
